'use strict';

var changelogHTML = require('../../../CHANGELOG.md');

function ctrl($scope) {
   $scope.changelogHTML = changelogHTML;
}

ctrl.$inject = ['$scope'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/changelog/controllers/main.js
 **/